export default {
  workspaceCode: 'jZlnKjAT1L4Qp9i2',
};
